import { withStyles } from "@material-ui/core/styles"
import Grid from "@material-ui/core/Grid"
import React from "react"
import Logo from "src/assets/SHARMBLE-LOGO-40x40.svg"

export default withStyles({
  header_container: { padding: "32px 24px" },
  logo: { width: 50 },
})(({ classes }) => (
  <Grid
    className={classes.header_container}
    container
    alignItems="center"
    justifyContent="center"
  >
    <img className={classes.logo} src={Logo} alt="logo" />
  </Grid>
))
